module.exports = __webpack_public_path__ + "static/media/check.065090b1.svg";